import {ResellJourneyBundleMutation} from "./resell-journey-bundle-mutation";
import {JourneyModel} from "../../journey/journey.model";

export class ResellReturnJourneyBundleMutation extends ResellJourneyBundleMutation {


    get journey(): JourneyModel {
        const journey = this.booking.unfilteredJourneys[1];
        if(!journey) {
            throw new Error('There is no return journey');
        }
        return journey;
    }

}
